import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { capitalize } from 'lodash';

import { ComponentJSSClasses } from './styles';


export interface HotelRoomFacilitiesProps {
    id: string;
    hotelCommonFacilities: Array<string>;
    hotelMealVariants: Array<string>;
}

export interface StyledHotelRoomFacilitiesProps extends JSSClassesProps<ComponentJSSClasses>, HotelRoomFacilitiesProps {}

export class HotelRoomFacilities extends React.Component<StyledHotelRoomFacilitiesProps, {}> {

    render() {
        const { classes } = this.props;

        if (!this.hasData) {
            return null;
        }

        return (
            <div
                className={classes.container}
                id={this.props.id}
            >
                {this.renderCommonFacilities()}
                {this.renderHotelMealVariants()}
            </div>
        );
    }

    renderCommonFacilities(): JSX.Element | null {
        const { classes } = this.props;

        if (!this.props.hotelCommonFacilities.length) {
            return null;
        }
        return (
            <div className={classes.item}>
                <span className={classes.title}>Обычно в номере</span>
                <p className={classes.text}>{capitalize(this.props.hotelCommonFacilities.join(', '))}</p>
            </div>
        );
    }

    renderHotelMealVariants(): JSX.Element | null {
        const { classes } = this.props;

        if (!this.props.hotelMealVariants.length) {
            return null;
        }
        return (
            <div className={classes.item}>
                <span className={classes.title}>Как можно питаться в отеле</span>
                <p className={classes.text}>{capitalize(this.props.hotelMealVariants.join(', '))}</p>
            </div>
        );
    }

    private get hasData(): boolean {
        return !!this.props.hotelCommonFacilities.length ||
            !!this.props.hotelMealVariants.length;
    }
}
